import { render } from "./PdpaContentModal.vue?vue&type=template&id=2e8551cf&scoped=true"
import script from "./PdpaContentModal.vue?vue&type=script&lang=js"
export * from "./PdpaContentModal.vue?vue&type=script&lang=js"

import "./PdpaContentModal.vue?vue&type=style&index=0&id=2e8551cf&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8551cf"]])

export default __exports__